<template>
  <div class="logo">
    <div :class="$store.state.isMobile ? 'h5Login' : ''">
      <pcLoginWarp :contentType="contentType" ref="pcLoginWarp">
        <!-- 密码登录 -->
        <div slot="inputs" v-if="contentType == 1">
          <div class="textButton">
            <div @click="fastLogin"></div>
            <div @click="toRegister">新用户注册</div>
          </div>
          <div class="inputPhone">
            <el-input v-model="login.mobilePhone" placeHolder="请输入手机号" type="number" oninput="if(value.length>11)value=value.slice(0,11)"></el-input>
          </div>
          <div class="inputCode">
            <el-input v-model="login.passWord" placeHolder="请输入密码" type="password"></el-input>
          </div>
          <div class="inputCode">
            <el-input v-model="login.authCode" placeHolder="请输入图片验证码"></el-input>
            <img :src="authCode" @click="reloadAuthCode" class="authCode">
          </div>
          <div class="textButton textButtons">
            <div @click="fastLogin">快捷登录</div>
            <div @click="resetPassword">重置密码</div>
          </div>
        </div>
        <div @click="loginIn" slot="button" :class="$store.state.isMobile ? 'buttonNormal' : 'buttonSumbit'" v-if="contentType == 1">登录</div>
        <!-- 快捷登录 -->
        <div v-if="contentType == 4" slot="inputs">
          <div class="textButton newRegister" v-if="!$store.state.isMobile">
            <div>快捷登录</div>
          </div>
          <div class="inputPhone">
            <el-input v-model="fast.mobilePhone" placeHolder="请输入手机号" type="number" oninput="if(value.length>11)value=value.slice(0,11)"></el-input>
          </div>
          <input type="password" style="display: none">
          <div class="inputCode">
            <el-input v-model="fast.authCode" placeHolder="请输入验证码" type="number" oninput="if(value.length>6)value=value.slice(0,6)"></el-input>
            <div class="button1" @click="getCode('fast')">{{hasCode ? `已发送(${timeNow}s)` : '获取验证码'}}</div>
          </div>
          <div @click="fastLogin" class="textButton">密码登录</div>
        </div>
        <div @click="loginIn('fast')" slot="button" :class="$store.state.isMobile ? 'buttonNormal' : 'buttonSumbit'" v-if="contentType == 4">登录</div>
        <!-- 重置登录 -->
        <div v-for="n in 3" :key="n" slot="resetIndex" :class="`resetIndex ${n == resetIndex ? 'resetActiveIndex' : ''}`" v-show="contentType == 2">
          {{n}}
        </div>
        <!-- 第一步 -->
        <div v-show="contentType == 2 && resetIndex == 1" slot="inputs">
          <div class="inputPhone">
            <el-input v-model="resetData.phone" placeHolder="请输入手机号" type="number" oninput="if(value.length>11)value=value.slice(0,11)"></el-input>
          </div>
          <div class="inputCode">
            <el-input v-model="resetData.verCode" placeHolder="请输入验证码" type="number" auto-complete="new-password"></el-input>
            <div class="button1" @click="getCode('reset')">{{hasCode ? `已发送(${timeNow}s)` : '获取验证码'}}</div>
          </div>
        </div>
        
        <!-- 第二步 -->
        <div v-show="contentType == 2 && resetIndex == 2" slot="inputs">
          <div class="inputCode">
            <el-input v-model="resetData.password" placeHolder="请输入密码" type="password" auto-complete="new-password"></el-input>
          </div>
          <div class="inputCode">
            <el-input v-model="resetData.conPassword" placeHolder="请确认密码" type="password" auto-complete="new-password"></el-input>
          </div>
        </div>
        <!-- 第三步 -->
        <div v-show="contentType == 2 && resetIndex == 3" slot="inputs" class="successReset">
          <!-- 江西书画院 -->
          <img src="../../assets/ticket/jxhy_logo.png" class="resetSuccessImg jxhyImg" v-if="$route.query.museumCode == 218425">
          <img src="../../assets/ticket/wbs1.png" class="resetSuccessImg" v-else>
          <div>恭喜您已重置密码，快来登录吧</div>
        </div>
        <div @click="resetNext" slot="button" :class="$store.state.isMobile ? 'buttonNormal' : 'buttonSumbit'" v-if="contentType == 2">{{resetText}}</div>
      </pcLoginWarp>
    </div>
  </div>
</template>

<script>
import axios from 'axios';
import pcLoginWarp from '../../components/ticket/pcLoginWarp.vue'

export default {
  data() {
    return {
      ticketDetail: {},
      statusText: ['停业', '开放', '约满'],
      login: {
        mobilePhone: '',
        authCode: '',
        passWord: ''
      },
      hasCode: false,
      timeNow: 60,
      timeInterval: '',
      authCode: '',
      contentType: 4, //1密码+图片验证码登录 2重置密码 4快捷登录
      resetIndex: 1,
      resetData: {
        phone: '',
        verCode: '',
        password: '',
        conPassword: ''
      },
      fast: {
        mobilePhone: '',
        authCode: ''
      },
      museumCode: '',
      buttonLock: false
    };
  },

  components: {pcLoginWarp},

  methods: {
    toRegister() {
      this.$router.push({path: '/ticket/register', query: this.$route.query})
    },

    fastLogin() {
      this.contentType == 1 ? this.contentType = 4 : this.contentType = 1
    },

    resetPassword() {
      this.contentType = 2
      this.resetIndex = 1
      this.$nextTick(() => {
        this.$refs.pcLoginWarp.setErCode()
      })
    },

    toHome() {
      // this.loginIn()
      this.$router.push({path: '/ticket/home', query: this.$route.query})
    },

    getCode(type) {
      let num = type == 'reset' ? this.resetData.phone : ( type == 'fast' ? this.fast.mobilePhone : this.login.mobilePhone )
      if (this.hasCode) return
      if (num.length != 11) return this.$message.error('请输入正确的手机号')
      this.$ajax(`/api/message/send/verification-code?phoneNumber=${num}`).then((res) => {
        this.$message.success("您的验证码已发送，5分钟内有效，请及时验证！")
        this.hasCode = true
        this.timeGo()
      })
    },

    timeGo() {
      this.timeNow = 60
      this.timeInterval = setInterval(() => {
        this.timeNow --
      }, 1000)
    },

    loginIn(type) {
      if (this.buttonLock) return
      this.buttonLock = true
      if (type == 'fast') { //快速登录
        this.fast.museumCode = this.museumCode
        if (!this.fast.authCode) {
          this.$message.error("请输入验证码")
          return this.buttonLock = false
        }
        this.$ajax.post('api/auth/jwt/member-token', this.fast).then((res) => {
          if (!res.data) return this.buttonLock = false
          if (this.$cookie.get('token')) {
            this.$cookie.delete('token')
            this.$cookie.delete('ticket_phone')
          }
          //手机号信息保存到store和token里
          this.$store.state.userPhone = this.fast.mobilePhone
          var pat =/(\d{3})\d*(\d{4})/;
          let phone = this.fast.mobilePhone.replace(pat,'$1****$2');
          this.$cookie.set('token', res.data)
          this.$cookie.set('ticket_phone', phone)
          this.loginBack()
          // this.$router.replace({path: '/ticket/home', query: this.$route.query})
          this.buttonLock = false
        }).catch(() => {
          this.buttonLock = false
        })
        return
      }
      // 账户密码登录
      if (isNaN(parseInt(this.museumCode,10))) { //老后台项目
          this.login.museumCode = this.museumCode
          this.$ajax.post('/api/auth/jwt/login', this.login).then((res) => {
          if (!res.data.token) return this.buttonLock = false
          if (this.$cookie.get('token')) {
            this.$cookie.delete('token')
            this.$cookie.delete('ticket_phone')
          }
          //手机号信息保存到store和token里
          this.$store.state.userPhone = this.login.mobilePhone
          var pat =/(\d{3})\d*(\d{4})/;
          let phone = res.data.mobilePhone.replace(pat,'$1****$2');
          this.$cookie.set('token', res.data.token)
          this.$cookie.set('ticket_phone', phone)
          this.loginBack()
          // this.$router.replace({path: '/ticket/home', query: this.$route.query})
          this.buttonLock = false
        }).catch(() => {
          this.buttonLock = false
        })
      } else { //fid的项目
        if (!this.login.mobilePhone || !this.login.passWord || !this.login.authCode) return this.buttonLock = false
        this.login.fid = this.museumCode
        this.$ajax.post('/api/auth/jwt/passport?pic=1', this.login).then((res) => {
          if (!res.rel) return this.buttonLock = false
          if (this.$cookie.get('token')) {
            this.$cookie.delete('token')
            this.$cookie.delete('ticket_phone')
          }
          //手机号信息保存到store和token里
          this.$store.state.userPhone = this.login.mobilePhone
          this.$cookie.set('token', res.data)
          var pat =/(\d{3})\d*(\d{4})/;
          let phone = this.login.mobilePhone.replace(pat,'$1****$2');
          this.$cookie.set('ticket_phone', phone)
          // window.localStorage.setItem('ticket_phone', this.login.mobilePhone)
          this.loginBack()
          // this.$router.replace({path: '/ticket/home', query: this.$route.query})
          this.buttonLock = false
        }).catch(() => {
          this.buttonLock = false
        })
      }
    },

    loginBack() {
      let urlPath = this.$route.params.backOtherPage ? `/ticket/${this.$route.params.backOtherPage}` : '/ticket/home'
      this.$route.params.backOtherPage ? this.$router.replace({path: urlPath, query: this.$route.query}) : this.$router.replace({path: '/ticket/home', query: this.$route.query})
    },

    reloadAuthCode() {
      let code = new Date().getTime()
      window.localStorage.setItem('authCode', code)
      process.env.NODE_ENV == 'development' ? this.getAuthCode() : 
      this.authCode = Glob.baseUrl + `/api/auth/jwt/back-code?t=${code}`
    },

    getAuthCode() {
      const NODE_ENV = process.env.NODE_ENV;
      const baseURL = process.env.NODE_ENV == 'development' ? '' : Glob.baseUrl
      const instance = axios.create({
        baseURL: baseURL
      })
      instance.interceptors.request.use((config) => {
        config.headers.Authorization = this.$cookie.get('token')
        return config
        }, (error) => {
      });
      let date = new Date()
      let code = new Date().getTime()
      window.localStorage.setItem('authCode', code)
      instance(`/api/auth/jwt/back-code?t=${code}`, {responseType: 'blob'}).then((res) => {
        console.log(res)
        this.authCode = window.URL.createObjectURL(res.data)
      })
    },

    resetNext() {
      if (this.resetIndex == 1 && (!this.resetData.phone || !this.resetData.verCode)) {
        return this.$message.error('请填写手机号和验证码')
      }
      if (this.resetIndex == 2) return this.submitReset()
      if (this.resetIndex == 3) {
        this.contentType = 1
        this.$nextTick(() => {
          this.$refs.pcLoginWarp.setErCode()
        })
        return
      }
      this.resetIndex ++
    },

    submitReset() {
      if (this.resetData.conPassword != this.resetData.password) return this.$message.error('两次密码不一致，请重试！')
      !isNaN(Number(this.$route.query.museumCode)) ? this.resetData.fid = this.museumCode : this.resetData.museumCode = this.museumCode
      this.$ajax.post('api/auth/jwt/reset', this.resetData).then((res) => {
        // if (!res.rel) {
        //   this.resetIndex = 1
        // }
        this.resetIndex ++
      })
    },

    getMuseum() {
      this.$ajax(`/api/admin/front/group/name?museumCode=${this.$route.query.museumCode}`).then((res) => {
        this.$store.state.museumName = res.data
      })
    },

  },

  created() {
    window.localStorage.removeItem('authCode')
    this.museumCode = this.$cookie.get('museumCode') || this.$route.query.museumCode
    if (this.$route.query.loginType) this.contentType = this.$route.query.loginType
    this.getMuseum()
  },

  watch: {
    timeNow(val) {
      if (val == 0) {
        clearInterval(this.timeInterval)
        this.hasCode = false
      }
    },

    contentType(val) {
      this.resetData = {
        phone: '',
        verCode: '',
        password: '',
        conPassword: ''
      }
      if (val == 1) {
        this.reloadAuthCode()
      }
    }
  },

  computed: {
    resetText() {
      return this.resetIndex < 3 ? '下一步' : '登录'
    },
  }
}
</script>

<style scoped lang="scss">
.logo{
  .logoContent{
    // margin: 8% 0 0 35%;
    margin-left: 30vw;
    padding: 15vh 0 0 5vw;
    height: 85vh;
    width: 63vw;
    position: relative;
    border-radius: 0.2rem;
    background-color: #fff;
    .name{
      font-size: 0.25rem;
      font-weight: 500;
      color: #333;
    }
    .inputPhone, .inputCode{
      width: 3.5rem;
      margin:auto;
      position: relative;
    }
    .inputPhone::before{
      display: inline-block;
      content: '';
      height: 0.26rem;
      width: 0.13rem;
      // background: url('~@/assets/ticket/icon_phone.png') 0 0/100% no-repeat;
      position: absolute;
      top: 0.14rem;
      left: 0.4rem;
      z-index: 222;
    }
    .inputCode::before{
      display: inline-block;
      content: '';
      height: 0.26rem;
      width: 0.13rem;
      // background: url('~@/assets/ticket/icon_password.png') 0 0/100% no-repeat;
      position: absolute;
      top: 0.14rem;
      left: 0.4rem;
      z-index: 222;
    }
    .inputCode img{
      position: absolute;
      top: 0.16rem;
      right: 0.3rem;
      cursor: pointer;
    }
    .button1{
      position: absolute;
      top: 0.17rem;
      right: 0.4rem;
    }

    .buttonSumbit{
      position: relative;
      padding-left: 0.3rem;
      width: 0.7rem;
      text-align: left;
      &::after{
        background: url('~@/assets/ticket/logo_icon.png') 0 0/100% no-repeat;
        height: 0.08rem;
        width: 0.16rem;
        content: '';
        display: inline-block;
        position: absolute;
        bottom: 0.13rem;
        right: 0.1rem;
      }
    }
    .textButton{
      width: 3rem;
      margin: auto;
      display: flex;
      justify-content: space-between;
      align-items: center;
      margin-bottom: 0.1rem;
      margin-top: 0.1rem;
      font-size: 0.12rem;
      font-weight: 500;
      cursor: pointer;
      &.newRegister{
        justify-content: center;
        font-size: 0.18rem;
        font-weight: bold;
      }
    }
  }
  .resetIndex{
    display: inline-block;
    height: 0.4rem;
    width: 0.4rem;
    color: #fff;
    font-size: 0.2rem;
    border-radius: 50%;
    line-height: 0.4rem;
    background-color: #c5c5c5;
    text-align: center;
    margin: 0.2rem 0.4rem;
  }
  .resetSuccessImg{
    width: 1rem;
    margin-bottom: 0.1rem;
  }
  .jxhyImg{
    margin: 0.3rem 0;
  }
  .buttonNormal{
    margin: auto;
    margin-top: 0.5rem;
  }

  .h5Login{
    .loginContent{
      .title{
        font-size: 0.6rem;
      }
    }
    .inputCode .authCode{
      position: absolute;
      bottom: 0.45rem;
      right: 0.8rem;
      height: 0.9rem;
    }
    .textButton{
      font-size: 0.4rem;
      text-align: left;
      margin-left: 0.5rem;
      // width: 3rem;
    }
    .textButtons{
      display: flex;
      justify-content: space-between;
      align-items: center;
      margin: 0 0.5rem;
    }
    .newRegister{
      // float: right;
      display: flex;
      justify-content: space-between;
      align-items: center;
      width: 7.7rem;
      margin-left: 0.7rem;
    }
    .resetIndex{
      height: 1rem;
      width: 1rem;
      line-height: 1rem;
      font-size: 0.5rem;
    }
    .inputCode{
      position: relative;
    }
    .button1{
      width: 2rem;
      height: 1.15rem;
      line-height: 1.15rem;
      right: 0.5rem;
      position: absolute;
      border-radius: 0.6rem;
      padding: 0 0.4rem;
      color: #fff;
      font-size: 0.35rem;
      top: 0.3rem;
    }
    .resetSuccessImg{
      width: 4rem;
    }
    .successReset{
      font-size: 0.4rem;
    }
  }
}
</style>
<style type="text/css">
  .logoContent .el-input__inner{
    width: 3rem;
    margin: 0.1rem;
    padding: 0.05rem 0.4rem;
    padding-right: 1rem;
    background-color: #f6f6f6;
    height: 0.35rem;
    border: unset;
    font-size: 0.11rem;
  }
  .inputCode .el-input__inner{
    /*width: 2rem;*/
    /*padding-right: ;*/
  }
  .h5Login .loginContent .title{
    font-size: 0.6rem;
    margin-bottom: 0.3rem;
  }
</style>
